import { render } from "./protocolClinic.vue?vue&type=template&id=e1a2b774&scoped=true"
import script from "./protocolClinic.vue?vue&type=script&lang=js"
export * from "./protocolClinic.vue?vue&type=script&lang=js"

import "./protocolClinic.vue?vue&type=style&index=0&id=e1a2b774&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-e1a2b774"

export default script